import React from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import ThemeContext from './ThemeContext';
import useTheme from './useTheme';

type Props = {
  value?: any;
  cdhilren?: any;
};

const ThemeProvider: React.FC<Props> = ({ value: _value, children }) => {
  const theme = useTheme();
  const value = _value ? _value : theme;
  return (
    <StyledThemeProvider theme={value}>
      <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
    </StyledThemeProvider>
  );
};

export default ThemeProvider;
